<section class="product-batch-edit-container"
         (click)="disablePropagation && $event.stopPropagation()"
         [class.wide]="type==='dimensions'">
  <div class="batch-edit-title" [innerHTML]="title"></div>
  <div class="batch-edit-body" [formGroup]="formGroup">
    <ng-container [ngSwitch]="type">
      <ng-container *ngSwitchCase="'price'">
        <div>
          <input class="ds-input"
                 formControlName="price"
                 appCurrencyMask
                 [symbol]="symbol"
                 type="text"
                 [placeholder]="symbol + ' 0.00'">
        </div>
        <div class="sale-price-container">
          <input type="checkbox"
                 class="ds-checkbox"
                 [checked]="editSale"
                 (change)="editSale =!editSale"
                 id="edit-price">
          <label for="edit-price" class="ds-checkbox-label black">
            Edit sale price
          </label>
          <div class="ds-input-wrap" *ngIf="editSale">
            <input class="ds-input"
                   formControlName="sale_price"
                   appCurrencyMask
                   [ngClass]="{'error':returnNum(formGroup.get('sale_price').value) > returnNum(formGroup.get('price').value)}"
                   [symbol]="symbol"
                   type="text"
                   [placeholder]="symbol + ' 0.00'">
            <span class="ds-input-error-msg">{{ 'text_salePriceMustBeLowerProductPrice' | dbText }}</span>
          </div>

        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'inventory'">
        <div>
          <input class="ds-input"
                 formControlName="inventory"
                 type="text"
                 placeholder="0">
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'status'">
        <div>
          <ds-dropdown [dsDropdownPlaceHolder]="'Choose a status'"
                       formControlName="status"
                       [dsDropdownOptions]="statusOptions"
                       [dsDropdownListMaxHeight]="'211px'">
          </ds-dropdown>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'dimensions'">
        <div class="dimensions-container">
          <div class="row">
            <div class="dimension-item">
              <div class="field-label">
                Shipping weight
              </div>
              <input class="ds-input"
                     formControlName="weight"
                     appCurrencyMask
                     [otherMeasurement]="measurements.weight_unit"
                     type="text"
                     placeholder="0">
            </div>
            <div class="dimension-item">
              <div class="field-label">
                Length
              </div>
              <input class="ds-input"
                     formControlName="length"
                     appCurrencyMask
                     [otherMeasurement]="measurements.dimension_unit"
                     type="text"
                     placeholder="0">
            </div>
          </div>
          <div class="row">
            <div class="dimension-item">
              <div class="field-label">
                Width
              </div>
              <input class="ds-input"
                     formControlName="width"
                     appCurrencyMask
                     [otherMeasurement]="measurements.dimension_unit"
                     type="text"
                     placeholder="0">
            </div>
            <div class="dimension-item">
              <div class="field-label">
                Height
              </div>
              <input class="ds-input"
                     formControlName="height"
                     appCurrencyMask
                     [otherMeasurement]="measurements.dimension_unit"
                     type="text"
                     placeholder="0">
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
  <div class="batch-edit-actions">
    <a class="ds-btn-gray ds-btn-small" (click)="discard()">
      <span>{{'text_productsDiscardBtn' | dbText}}</span>
    </a>
    <a class="ds-btn-black ds-btn-small" [class.ds-btn-disabled]=" type==='price' && returnNum(formGroup.get('sale_price').value) > returnNum(formGroup.get('price').value)"
       (click)="add()">
      <span>{{ 'text_done' | dbText }}</span>
    </a>
  </div>
</section>
